const fonts = {
  heading: "'Averta', sans-serif",
  body: "'Montserrat', sans-serif",
};

export default fonts;
